import type { ReactNode } from 'react'

type Props = {
  title: string
  lead?: string
  className?: string
  children?: ReactNode
}

/** Shared step heading — matches Condition step (builder-step-surface__head). */
export default function BuilderStepHead({ title, lead, className, children }: Props) {
  return (
    <header className={['builder-step-surface__head', className].filter(Boolean).join(' ')}>
      <h3 className="builder-step-surface__title">{title}</h3>
      {lead ? <p className="builder-step-surface__lead">{lead}</p> : null}
      {children}
    </header>
  )
}
